import classNames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';

import { ComparisonTableHeaderProps } from './ComparisonTableTypes';

import './ComparisonTableHeader.scss';

type ComparisonTableHeaderPropsWithKey = ComparisonTableHeaderProps & { key: string };

export const ComparisonTableHeader = ({
    title,
    description,
    color = 'light-grey',
    recommendationLabel,
    key,
}: ComparisonTableHeaderPropsWithKey) => {
    return (
        <th
            className={classNames('comparison-table-header__wrapper', {
                'comparison-table-header__wrapper--recommended': recommendationLabel,
            })}
            scope="col"
            key={key}
        >
            {recommendationLabel && (
                <>
                    <Icon
                        type={IconTypes.STJERNEDRYSS_24}
                        wrapperClassName="comparison-table-header__recommendation-icon"
                    />
                    <div className="comparison-table-header__recommendation-label-wrapper">
                        <span className="comparison-table-header__recommendation-label-arrow" />
                        <span className="comparison-table-header__recommendation-label">{recommendationLabel}</span>
                    </div>
                </>
            )}
            <span
                className={classNames('comparison-table-header__text-container', {
                    [`comparison-table-header__text-container--${color}`]: color,
                })}
            >
                <span
                    className={classNames('comparison-table-header__title', {
                        'comparison-table-header__title--without-description': !description,
                    })}
                >
                    {title}
                </span>
                {description && <span className="comparison-table-header__subtitle">{description}</span>}
            </span>
        </th>
    );
};
